// libraries.
import { useNavigate } from "react-router-dom";

// components.
import { SidebarButton } from "@shared/Sidebar/components/SidebarButton/SidebarButton";
import { useSidebarContext } from "@shared/Sidebar";

// types.
import { SIDEBAR_BUTTON_SUPPORT } from "../sidebarHome.types";

// assets.
import { IconSupport } from "@assets";
import { pathSupport } from "@routes/routes.types";
import { pathSupportMain } from "@pages/SupportPage/routes/routes.types";

export const ButtonSupport = () => {
  const navigate = useNavigate();
  const {
    setSelectedButton,
    state: { selectedSidebarButton },
  } = useSidebarContext();

  const handleOnClick = () => {
    setSelectedButton(SIDEBAR_BUTTON_SUPPORT);
    navigate(`${pathSupport}/${pathSupportMain}`);
  };

  return (
    <SidebarButton
      hoverText="Soporte"
      onClick={handleOnClick}
      selected={selectedSidebarButton === SIDEBAR_BUTTON_SUPPORT}
    >
      <IconSupport fill="white" />
    </SidebarButton>
  );
};
